import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { TiaowenList } from "../../utils";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import SERVER_ADDRESS from "../../../../config";

function GoujianTypes(props) {
  return null;
}

export default GoujianTypes;
